const mobileFacets = document.querySelector('.mobile-facets__disclosure');
const filterHotLinks = document.querySelectorAll('.filter-hot-link');

if (filterHotLinks.length) {
  filterHotLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const hotLinkValue = link.dataset.filterHotLinkValue?.toLowerCase().trim();

      mobileFacets.classList.add('menu-opening');
      mobileFacets.setAttribute('open', '');
      document.body.classList.add('overflow-hidden-mobile');

      const colorDetails = document.querySelector(`.mobile-facets__details--${hotLinkValue}`);
      if (colorDetails) {
        colorDetails.setAttribute('open', '');
      }
    });
  });
}
